import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from "react";
import { Input, Label } from "reactstrap";
import Modal from "../../../../../Basic/Modal";
import { rejectUserRequest } from "../../../../api/accountSetting.api";
import { notifyErrorToast } from "../../../../utils/errorToast";

function RejectRequestModal(props) {
  var prefix = props.prefix,
      translate = props.translate,
      isOpen = props.isOpen,
      request = props.request,
      onToggle = props.onToggle,
      onClose = props.onClose,
      onRejectedSuccess = props.onRejectedSuccess,
      setProcessed = props.setProcessed,
      setProcessedMsg = props.setProcessedMsg;
  var componentClass = "".concat(prefix, "-user-request-deny-modal");

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      message = _useState2[0],
      setMessage = _useState2[1];

  var onReject = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _error$response, _error$response2, errorStatus, _message, _message$data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return rejectUserRequest({
                invitationId: request.id,
                comment: message
              });

            case 3:
              onClose();
              onRejectedSuccess();
              _context.next = 17;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              errorStatus = (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
              _message = (_error$response2 = _context.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data;

              if (!(errorStatus === 400 && (_message === null || _message === void 0 ? void 0 : _message.errorCode) === '2x4')) {
                _context.next = 16;
                break;
              }

              setProcessed(true);
              setProcessedMsg({
                status: (_message$data = _message.data) === null || _message$data === void 0 ? void 0 : _message$data.status,
                message: _message
              });
              onClose();
              return _context.abrupt("return");

            case 16:
              if (errorStatus === 404) {
                notifyErrorToast(translate('SFxUnknownError'));
              }

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function onReject() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(Modal, {
    centered: true,
    backdrop: 'static',
    className: "account-settings-modal ".concat(componentClass),
    modalTitle: translate('SFxAccountSettingsUserRequestDenyTitle'),
    isOpen: isOpen,
    toggle: onToggle,
    onCancel: onClose,
    onOk: function onOk() {
      onReject();
    },
    cancelText: translate('SFxAccountSettingsUserRequestDenyCancel'),
    okText: translate('SFxAccountSettingsUserRequestDenyOK')
  }, /*#__PURE__*/React.createElement("h3", null, translate('SFxAccountSettingsUserRequestDenyTitle')), /*#__PURE__*/React.createElement("p", {
    className: "".concat(componentClass, "-text")
  }, translate('SFxAccountSettingsUserRequestDenyConfirm'), ' ', /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-text-accent")
  }, request.email), " ?"), /*#__PURE__*/React.createElement("p", {
    className: "".concat(componentClass, "-text")
  }, translate('SFxAccountSettingsUserRequestDenyConfirmDetail1'), /*#__PURE__*/React.createElement("br", null), translate('SFxAccountSettingsUserRequestDenyConfirmDetail2')), /*#__PURE__*/React.createElement("p", {
    className: "".concat(componentClass, "-text")
  }, translate('SFxAccountSettingsUserRequestRequestor'), /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-text-accent")
  }, " ".concat(request.creatorFullName, ", ").concat(request.creatorEmail))), /*#__PURE__*/React.createElement(Label, {
    for: "denyRequestMessage",
    className: "".concat(componentClass, "-text ").concat(componentClass, "-message-label")
  }, translate('SFxAccountSettingsUserRequestDenyLabel')), /*#__PURE__*/React.createElement(Input, {
    id: "denyRequestMessage",
    type: "textarea",
    className: "".concat(componentClass, "-message-input"),
    value: message,
    onChange: function onChange(e) {
      setMessage(e.target.value);
    }
  }));
}

export default RejectRequestModal;